// Default page number to start pagination
export const DEFAULT_PAGE = 1;

// Number of items per page (can vary based on context)
export const DEFAULT_PAGE_SIZE = 12;

// Page size options (for dropdowns)
export const PAGE_SIZE_OPTIONS = [12, 24, 48, 96];

// Max pages to show in pagination component
export const MAX_PAGINATION_DISPLAY = 5;
